import { render, staticRenderFns } from "./searchresultitem.vue?vue&type=template&id=3ddd6998&"
import script from "./searchresultitem.vue?vue&type=script&lang=ts&"
export * from "./searchresultitem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ddd6998')) {
      api.createRecord('3ddd6998', component.options)
    } else {
      api.reload('3ddd6998', component.options)
    }
    module.hot.accept("./searchresultitem.vue?vue&type=template&id=3ddd6998&", function () {
      api.rerender('3ddd6998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/search/searchresultitem.vue"
export default component.exports